<div class="stepper-progress">
  <htx-stepper-header
    [steps]="steps()"
    [currentStep]="currentStep()">
  </htx-stepper-header>

  <div class="stepper-content">
    @let step = steps()[currentStep()];
    @if (step.badge || step.title || step.description) {
      <htx-step-header
        [badge]="step.badge || ''"
        [title]="step.title || ''"
        [descriptions]="step.description || []">
      </htx-step-header>
    }
    <ng-content></ng-content>
  </div>

  <htx-stepper-action-bar
    [layout]="computedActionBarLayout()"
    [gap]="actionBarGap()"
    [showDivider]="showDivider()"
    [previousLabel]="previousLabel()"
    [nextLabel]="nextLabel()"
    [lastStepLabel]="lastStepLabel()"
    [previousDisabled]="previousDisabled()"
    [nextDisabled]="nextDisabled()"
    (previous)="onPrevious()"
    (next)="onNext()"
    (lastStep)="onLastStep()">
  </htx-stepper-action-bar>
</div>
